import './App.css';
import { useEffect, useState } from 'react';
import Departments from './components/View/Departments/Departments';
import Header from './components/View/Header/Header';
import Footer from './components/View/Footer/Footer';
import Login from './components/View/Login/Login'
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Confetti from "react-confetti";
import moneySFX from "./media/audio/money.mp3";
import monke from "./media/img/monke.gif"
import saba from './media/img/saba.gif'
import daboss from './media/img/daboss.gif'
import kim from './media/img/kim.gif'
import yana from './media/img/yana.gif'
import ross from './media/img/Ros-da-boss.gif'
function App() {
  const URL = "https://salesboard3100.herokuapp.com"
  const guest = {
    id: "GUESTID",
    username: "Guest",
    password: "",
    admin: false,
    accessToken: ""
  }
  const [DepartmentsData, setDepartmentsData] = useState([])
  const [SalesData, setSalesData] = useState([])
  const [EmployeesData, setEmployeesData] = useState([])
  const [ImagesData, setImagesData] = useState([])
  const [User, setUser] = useState(guest)
  const [Clock, setClock] = useState(false)
  const [Username, setUsername] = useState("")
  const [Password, setPassword] = useState("")
  const [LastSale, setLastSale] = useState({ _id: "" })
  const [InitialLogin, setInitialLogin] = useState(true)
  const [ConfettiRun, setConfettiRun] = useState(false);
  const [RecycleRun, setRecycleRun] = useState(false);
  const [Gif, setGif] = useState("")
  const daMoney = new Audio(moneySFX);
  function playSound() {
    ImagesData.length > 1 ? randomAnswer(ImagesData) : randomAnswer(picsArr)
    setConfettiRun(true);
    setRecycleRun(true);
    daMoney.play();
    setTimeout(() => setConfettiRun(false), 20000);
    setTimeout(() => setRecycleRun(false), 10000);
  }
  function handleClock() {
    setClock(!Clock)
  }
  useEffect(() => {
    let tmp = setInterval(() => {

      handleClock()
    }, 1000);
    return () => { clearInterval(tmp); };
  })
  function saveToken(token) {
    setUser(token)
    localStorage.setItem("token", JSON.stringify(token))
  }

  useEffect(() => {
    let token = localStorage.getItem("token")
    JSON.parse(token) == null ? console.log("please login") : setUser(JSON.parse(token))

  }, [])
  function login() {
    let requestOptions = {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        username: Username,
        password: Password
      })
    }
    fetch(`${URL}/users/login`, requestOptions).then(
      e => e.json()
    ).then(json => {

      !json.admin ? toast.warn(
        <div>
          <h5>Please enter the correct info</h5>
        </div>
      ) : saveToken(json)
    })
  }
  // useEffect(() => {
  //   login()
  // }, [])
  // useEffect(() => {
  //   let requestOptions = {
  //     method: "POST",
  //     headers: {
  //       'Content-Type': 'application/json',
  //     },
  //     body: JSON.stringify({
  //       username: "gman",
  //       password: "kakipipi"
  //     })
  //   }
  //   fetch(`${URL}/users/login`, requestOptions).then(
  //     e => e.json()
  //   ).then(json => {
  //     setUser(json)
  //   })
  // }, [])
  useEffect(() => {
    let requestOptions = {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        'x-access-token': User.accessToken
        // 'x-access-token': User.accessToken
      }
    }
    if (User.accessToken !== "") {
      fetch(`${URL}/departments`, requestOptions).then(
        e => e.json()
      ).then(json => {
        if (json.message) {
          if (json.message == "Unauthorized!") {
            setUser(guest)
          }
        }
        setDepartmentsData(json)
        // console.log(json)
      })
      fetch(`${URL}/sales`, requestOptions).then(
        e => e.json()
      ).then(json => {
        setSalesData(json)
        if (InitialLogin) {
          setInitialLogin(false)
        } else {
          if (json.length > SalesData.length) {
            playSound()
          }
        }
        setLastSale(json[json.length - 1])

      })
      fetch(`${URL}/employees`, requestOptions).then(
        e => e.json()
      ).then(json => {
        setEmployeesData(json)
        // console.log(json)
      })
      fetch(`${URL}/images`, requestOptions).then(
        e => e.json()
      ).then(json => {
        setImagesData(json)
      })
    }
  }, [Clock, User])

  const picsArr = [
    { src: monke },
    { src: daboss },
    { src: saba },
    { src: kim },
    { src: yana },
    { src: ross }
  ]

  const backgroundGif = ConfettiRun ? { backgroundImage: `url(${Gif.src})` } : { background: `linear-gradient(100deg, #d2d6ce, #f7f3eb)`, }
  function randomAnswer(array) {
    setGif(array[Math.floor(Math.random() * array.length)]);
  }
  // useEffect(() => {
  //   randomAnswer(picsArr)
  //   setConfettiRun(true)

  // }, [])
  return (
    <div style={backgroundGif} className="App">
      <div style={{ position: 'absolute', zIndex: '-100', opacity: "0" }}>
        {ImagesData.length > 1 ? ImagesData.map(pic =>
          (<img src={pic.src} alt="" />)
        ) : picsArr.map(pic =>
          (<img src={pic.src} alt="" />)
        )}

      </div>
      <Header />
      <div className='ftd-message' style={{ display: !ConfettiRun ? "none" : "flex" }}>
        NEW FTD<br />
        BY {EmployeesData.length > 0 && LastSale._id != "" && EmployeesData.filter(e => e._id == LastSale.employeeId)[0].firstName} {EmployeesData.length > 0 && LastSale._id != "" && EmployeesData.filter(e => e._id == LastSale.employeeId)[0].lastName}<br />
        FOR {EmployeesData.length > 0 && LastSale._id != "" && LastSale.saleSum * LastSale.exchangeRate}$
      </div>
      <div className='departments-container' style={{ display: ConfettiRun ? "none" : "flex" }}>
        {!User.admin ?
          <Login
            User={User}
            login={login}
            setUsername={setUsername}
            setPassword={setPassword}
            Username={Username}
            Password={Password}
          />
          :
          <Departments
            URL={URL}
            User={User}
            depId={"61b0eb7df303c027543b89d1"}
            SalesData={SalesData}
            DepartmentsData={DepartmentsData}
            EmployeesData={EmployeesData}
          />}
      </div>
      <ToastContainer
        position="top-center"
        autoClose={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
      />
      <Confetti
        recycle={RecycleRun}
        numberOfPieces={10}
        run={ConfettiRun}
        confettiSource={{
          y: window.innerHeight / 1.1,
          // x: window.innerWidth / 2,
          w: window.innerWidth,
          h: 1,
        }}
        gravity={-0.1}
        initialVelocityY={{ min: 0.2, max: 1 }}
        colors={["green"]}
        drawShape={(context) => {
          context.beginPath();
          context.fillRect(10, 10, 35, 20);
        }}
        width={window.innerWidth}
        height={window.innerHeight}
      />
      <Footer />
    </div>
  );
}

export default App;
